import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
const features = ['Unlimited kitties for every group', 'Invite as many friends as you want', 'Log expenses in seconds', 'See who owes what in real time', 'Calculate the simplest way to settle'];
export function Pricing() {
  const scrollToWaitlist = () => {
    document.getElementById('waitlist')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="pricing" className="py-28 lg:py-36 bg-gray-50" data-id="element-169" data-mp="1vw4ljfxlht3f">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-170" data-mp="1rtrnzet051hq">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="text-center max-w-2xl mx-auto mb-16" data-id="element-171" data-mp="25sr23siw1xzn">
          <p className="text-sm font-semibold text-kitty-yellow-600 uppercase tracking-widest mb-3" data-id="element-172" data-mp="3c8jwdgswas07">
            Pricing
          </p>
          <h2 className="text-3xl md:text-5xl font-black text-kitty-dark mb-4 tracking-tight" data-id="element-173" data-mp="3vyf7utymt42w">
            Free during early access.
          </h2>
          <p className="text-lg text-gray-500 max-w-lg mx-auto" data-id="element-174" data-mp="4uyvx2nkycbb">
            Get the full shared-expense experience for £0 while early access is open.
          </p>
        </motion.div>

        <div className="max-w-lg mx-auto" data-id="element-175" data-mp="ep8xnayewmyp">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-white rounded-[2rem] p-8 md:p-12 shadow-card border border-gray-100 relative overflow-hidden" data-id="element-176" data-mp="3d9h5j8t65zx1">
            {/* Yellow top accent line */}
            <div className="absolute top-0 left-0 right-0 h-1.5 bg-kitty-yellow" data-id="element-177" data-mp="3rzy7qudmotuz" />

            <div className="text-center mb-10 mt-2" data-id="element-178" data-mp="2uhy4h7ipgvxn">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-green-50 text-green-700 text-sm font-medium mb-4" data-id="element-179" data-mp="2zh0zs08vvnsf">
                <span className="w-2 h-2 rounded-full bg-green-500" data-id="element-180" data-mp="2rfa5bofdidfv" />
                Early access pricing
              </div>
              <div className="flex items-baseline justify-center gap-2" data-id="element-181" data-mp="2mfp417cqdszz">
                <span className="text-5xl md:text-6xl font-extrabold text-kitty-dark" data-id="element-182" data-mp="3164up1nx1t5j">
                  £0
                </span>
                <span className="text-gray-400 text-lg" data-id="element-183" data-mp="2w9xn74fvg9lh">/month</span>
              </div>
            </div>

            <ul className="space-y-4 mb-10" data-id="element-184" data-mp="23ixg2km8uppl">
              {features.map(feature => <li key={feature} className="flex items-center gap-3" data-id="element-185" data-mp="23kqljwl4f3w0">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 flex items-center justify-center" data-id="element-186" data-mp="2ih81700cf4od">
                    <CheckIcon className="w-3.5 h-3.5 text-green-600" data-id="element-187" data-mp="2dfinfclqkcwl" />
                  </div>
                  <span className="text-gray-700 font-medium" data-id="element-188" data-mp="3tts89wqrrjio">{feature}</span>
                </li>)}
            </ul>

            <button onClick={scrollToWaitlist} className="w-full bg-kitty-yellow hover:bg-kitty-yellow-500 text-kitty-dark py-4 rounded-full font-bold text-lg transition-all active:scale-[0.98] shadow-md hover:shadow-lg flex items-center justify-center gap-2" data-id="element-189" data-mp="3ovz1b1hn6lhc">
              Join the waitlist
              <ArrowRightIcon className="w-5 h-5" data-id="element-190" data-mp="3ngwdg9us0o4z" />
            </button>

            {/* Early access note */}
            <p className="text-center text-xs text-gray-500 mt-5 font-medium" data-id="element-191" data-mp="3rirh3l06jdlx">
              🚀 Limited spots — join early access now
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}